import React, {useState, useEffect} from 'react';
import { Row, Empty, Typography } from 'antd';
import NivoTreeChart from "../../../charts/nivo/NivoTreeChart";
import { SectorIndustryMapping } from "../../../Configs/DataMappings";
import { getRandomColor } from "../../../utils/colorUtils";
import Orientation from "../../../Components/Orientation";
import Refresh from '../../../Components/Refresh';

const _OrientText = ()=>(<span>
  The Allocations shows you a detailed breakdown of all the sectors and industries forming your portfolio, including
    composite allocations for any ETFs
</span>);



const AllocationsView = ({ sectors, industries, showOrient=false }) => {
  // Build tree data structure for NivoTreeChart
  const [orientVisible, setOrientVisible] = useState(localStorage.getItem('ptflview_allocations_orient_1') || true);

  useEffect(() => {
      return () => {setOrientVisible(false)}}, []);

  const buildTreeData = () => {
    // Root node
    let treeData = { name: 'Sectors & Industries', children: [] };

    // Loop through each sector in SectorIndustryMapping
    Object.entries(SectorIndustryMapping).forEach(([sectorKey, industryArray]) => {
      // Get the percentage value for the sector
      const sectorValue = sectors[sectorKey];

      // Create a node for this sector
      let sectorNode = {
        name: sectorKey,
        color: getRandomColor(), // Optional, if you want to customize colors
        children: industryArray.map(industryKey => ({
          // Map each industry to a child node, including its percentage value
          name: industryKey,
          color: getRandomColor(), // Optional, for color customization
          value: (industries[industryKey] * 100).toFixed(1), // Convert decimal to percentage
        })).filter(industryNode => industryNode.value > 0) // Optional, filter out industries with no value
      };

      // Add the sector node to the tree, if it has any children industries
      if (sectorNode.children.length > 0) {
        treeData.children.push(sectorNode);
      }
    });

    return treeData;
  };

  const treeData = buildTreeData();

  return (
      <>
          <Row className={'p-6'} align={'middle'}>
            <div style={{height: '70vh', width: '100%'}}>
                {treeData.children.length > 0 ? (
                  <NivoTreeChart data={treeData} />
                ) : (
                  <Empty description="No Data Available" />
                )}
            </div>
          </Row>
          {showOrient&&(
              <>
                  <Orientation
                    title="Allocations"
                    visible={orientVisible}
                    onToggle={setOrientVisible}
                    children={<>
                        <_OrientText/>
                    </>}

                />
              </>
      )}
      </>
  );
};

export default AllocationsView;
